import { isAndroid, isIOS, isMobile, isTablet, isFirefox } from 'react-device-detect';
import theme from 'shared/assets/style/theme';
import { height as NavHeight } from 'shared/components/NavigationBar/sizes';
import Utils from 'shared/utils/index';
import { isNotStandaloneMobilePWA, isStandalonePWA, pwaStyleAdapter } from '../utils/mobileSupported';
import defaultTheme from './defaultTheme';

const windowWidth = window.innerWidth;
const windowHeight = window.innerHeight;

const ScrollBar = {
  ...defaultTheme.ScrollBar,
  backgroundColor: theme.palette.primary[31],
};

const TiTheme = {
  //TODO: Refactor ScrollBar styles
  ...defaultTheme,
  ScrollBar,
  LimitedTimeOffer: {
    ...defaultTheme.LimitedTimeOffer,
    BannerContainer: {
      ...defaultTheme.LimitedTimeOffer.BannerContainer,
      marginBottom: '.75%',
    },
    BuyButton: {
      ...defaultTheme.LimitedTimeOffer.BuyButton,
      bottom: '6%',
      transform: 'translateX(-1%)',
    },
    BannerContainerText: {
      ...defaultTheme.LimitedTimeOffer.BannerContainerText,
      paddingLeft: '3vmin',
      position: 'relative',
      top: '0rem',
    },
  },
  NavigationBar: {
    ...defaultTheme.NavigationBar,
    LoyaltyBarContainer: {
      ...defaultTheme.NavigationBar.LoyaltyBarContainer,
      marginLeft: '-0.3rem',
    },
    LoyaltyCurrencyWrapperStyle: {
      ...defaultTheme.NavigationBar.LoyaltyCurrencyWrapperStyle,
      right: `calc(50% - ${windowWidth < 1300 ? 175 : windowWidth < 1400 ? 170 : 220}px)`,
    },
    LoyaltyCurrencyWrapperStyleWithoutCard: {
      ...defaultTheme.NavigationBar.LoyaltyCurrencyWrapperStyleWithoutCard,
      right: `calc(50% - ${windowWidth < 1400 ? 215 : 240}px)`,
    },
    LoyaltyCurrencyIconStyle: {
      ...defaultTheme.NavigationBar.LoyaltyCurrencyIconStyle,
      height: 60,
      width: 60,
      top: -15,
    },
    LoyaltyCurrencyIconStyleWithMissionsbar: {
      ...defaultTheme.NavigationBar.LoyaltyCurrencyIconStyleWithMissionsbar,
      marginLeft: windowWidth < 1300 ? 10 : windowWidth < 1400 ? 15 : '8px',
    },
    TopBar: {
      ...defaultTheme.NavigationBar.TopBar,
      height: isMobile && !isTablet ? '5.7rem' : '6rem',
    },
    BarSection: {
      ...defaultTheme.NavigationBar.BarSection,
      paddingBottom: 10,
      maxWidth: Utils.ieVersion() !== 0 ? 1430 : 1600,
    },
    HomeIcon: {
      ...defaultTheme.NavigationBar.HomeIcon,
      ...(isMobile && !isTablet && { marginBottom: '1.5vh' }),
    },
  },
  TermsModalWrapper: {
    ...defaultTheme.TermsModalWrapper,
    HeaderImage: {
      ...defaultTheme.TermsModalWrapper.HeaderImage,
      width: isTablet ? 'calc(100% + 7px)' : '100%',
      left: isTablet ? -3 : 0,
    },
  },
  ForgotPassword: {
    ...defaultTheme.ForgotPassword,
    ModalContainer: {
      ...defaultTheme.ForgotPassword.ModalContainer,
      height: isMobile ? '55vh' : '70vh',
      minHeight: '300px',
    },
  },
  Home: {
    ...defaultTheme.Home,
    GameListWrapper: {
      ...defaultTheme.Home.GameListWrapper,
      marginTop: isFirefox && isStandalonePWA ? '-1rem' : (isStandalonePWA || isIOS) ? 0 : '2rem',
      paddingBottom: isIOS && isNotStandaloneMobilePWA ? '1rem' : '2rem',
    },
  },
  Tier: {
    ...defaultTheme.Tier,
    Card: {
      ...defaultTheme.Tier.Card,
      width: 75,
    },
    TierWrapper: {
      ...defaultTheme.Tier.TierWrapper,
      marginRight: windowWidth < 1400 ? '75px !important' : '85px !important',
    },
  },
  DefaultTooltip: {
    ...defaultTheme.DefaultTooltip,
    Border: {
      ...defaultTheme.DefaultTooltip.Border,
      stopColor1: '#0c1f3f',
      stopColor2: '#0c1f3f',
    },
    Background: {
      ...defaultTheme.DefaultTooltip.Background,
      stopColor1: '#2b527b',
      stopColor2: '#2b527b',
    },
  },
  BonusLinkMessage: {
    ...defaultTheme.BonusLinkMessage,
    PromoImage: {
      ...defaultTheme.BonusLinkMessage.PromoImage,
      paddingTop: '376px',
    },
    BonusLinkButton: {
      ...defaultTheme.BonusLinkMessage.BonusLinkButton,
      textShadow: `1px 1px 0px ${theme.palette.secondary[0]}, 1px -1px 0px ${theme.palette.secondary[0]}, -1px 1px 0px ${theme.palette.secondary[0]}, -1px -1px 0px ${theme.palette.secondary[0]}`,
    },
    CoinsBonusContainer: {
      ...defaultTheme.BonusLinkMessage.CoinsBonusContainer,
      paddingTop: isMobile && isAndroid ? '363px' : '376px',
    },
    BonusInfoContainer: {
      ...defaultTheme.BonusLinkMessage.BonusInfoContainer,
      marginBottom: '15px',
    },
    LPBonusContainer: {
      ...defaultTheme.BonusLinkMessage.LPBonusContainer,
      paddingTop: '337px',
    },
    CoinIcon: {
      ...defaultTheme.BonusLinkMessage.CoinIcon,
      width: 29,
      height: 40,
      marginTop: 5,
    },
    LoyaltyIcon: {
      ...defaultTheme.BonusLinkMessage.LoyaltyIcon,
      width: '38px',
      marginRight: 0,
    },
    CoinsBonusText: {
      ...defaultTheme.BonusLinkMessage.CoinsBonusText,
      fontSize: '18px',
    },
    LoyaltyBonusText: {
      ...defaultTheme.BonusLinkMessage.LoyaltyBonusText,
      fontSize: '18px',
    },
  },
  OutOfCoin: {
    ...defaultTheme.OutOfCoin,
    QuickBuyOfferDetails: {
      ...defaultTheme.OutOfCoin.QuickBuyOfferDetails,
      bottom: '15.5%',
    },
    OutOfCoinButtons: {
      ...defaultTheme.OutOfCoin.OutOfCoinButtons,
      marginTop: '-2.9%',
    },
  },
  Settings: {
    ...defaultTheme.Settings,
    HeaderImage: {
      ...defaultTheme.Settings.HeaderImage,
      height: '6rem',
    },
    HeaderContent: {
      ...defaultTheme.Settings.HeaderContent,
      height: '80%',
    },
    BackArrowContainer: {
      ...defaultTheme.Settings.BackArrowContainer,
      top: '1.5rem',
    },
  },
  OfferDetail: {
    ...defaultTheme.OfferDetail,
    CarouselIndicator: {
      ...defaultTheme.OfferDetail.CarouselIndicator,
      backgroundColor: theme.palette.secondary[2],
      boxShadow: 'inset 0 0 10px black',
      border: 0,
    },
    CarouselIndicatorActive: {
      ...defaultTheme.OfferDetail.CarouselIndicatorActive,
      backgroundColor: theme.palette.primary[31],
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.4)',
      border: 0,
    },
  },
  CreditCardDetails: {
    ...defaultTheme.CreditCardDetails,
    CheckBoxBackgroundImage: {
      ...defaultTheme.CreditCardDetails.CheckBoxBackgroundImage,
      width: '40%',
    },
  },
  LinkAccountForm: {
    ...defaultTheme.LinkAccountForm,
    HeaderImage: {
      ...defaultTheme.LinkAccountForm.HeaderImage,
      height: '6rem',
    },
    HeaderTitle: {
      ...defaultTheme.LinkAccountForm.HeaderTitle,
      fontSize: isTablet ? (isAndroid ? '1.4vw' : '1.8vw') : isMobile ? '1.55vw' : '1.6rem',
      lineHeight: '72px',
    },
    NeedHelpText: {
      ...defaultTheme.LinkAccountForm.NeedHelpText,
      top: '1.7rem',
    },
    FormContainer: {
      ...defaultTheme.LinkAccountForm.FormContainer,
      margin: '50px',
      marginBottom: '10px',
    },
  },
  RegisterRewardCard: {
    ...defaultTheme.RegisterRewardCard,
    HeaderImage: {
      ...defaultTheme.RegisterRewardCard.HeaderImage,
      height: '6rem',
    },
    HeaderTitle: {
      ...defaultTheme.RegisterRewardCard.HeaderTitle,
      lineHeight: '80px',
    },
    FormDescription: {
      ...defaultTheme.RegisterRewardCard.FormDescription,
      marginTop: '20px',
    },
  },
  DailySpin: {
    ...defaultTheme.DailySpin,
    BottomBarBackgroundWrapperImage: {
      ...defaultTheme.DailySpin.BottomBarBackgroundWrapperImage,
      width: '120%',
      height: '150%',
    },
    MilestoneLoyaltyValue: {
      ...defaultTheme.DailySpin.MilestoneLoyaltyValue,
      marginLeft: isMobile ? -2 : 0,
      marginBottom: isAndroid ? 2 : 0,
    },
    MilestoneCoinsValue: {
      ...defaultTheme.DailySpin.MilestoneCoinsValue,
      marginBottom: 2,
    },
    mileStoneRowCoinIcon: {
      ...defaultTheme.DailySpin.mileStoneRowCoinIcon,
      marginBottom: 0,
    }
  },
  BottomBar: {
    ...defaultTheme.BottomBar,
    NotificationMail: {
      ...defaultTheme.BottomBar.NotificationMail,
      left: '1.5em',
    },
    ChestOpenBarIcon: {
      ...defaultTheme.BottomBar.ChestOpenBarIcon,
      left: isMobile && !isTablet ? '1.3em' : '0.5em',
      marginBottom: isTablet ? '-0.5rem' : isMobile ? '-0.5vh' : '-0.7rem',
    },
    ChestClosedBarIcon: {
      ...defaultTheme.BottomBar.ChestClosedBarIcon,
      left: isMobile && !isTablet ? '1.3em' : '0.5em',
      marginBottom: isTablet ? '-0.5rem' : isMobile ? '-0.5vh' : '-0.7rem',
    },
    TimerLabel: {
      ...defaultTheme.BottomBar.TimerLabel,
      position: 'relative',
      bottom: 0,
      paddingLeft: isTablet ? '18%' : '20%',
      marginBottom: isTablet ? '-4%' : isMobile ? '-2.5%' : '-13.5%',
    },
    TimerWrapper: {
      ...defaultTheme.BottomBar.TimerWrapper,
      height: '70%',
      width: isMobile && !isTablet ? '105%' : '112%',
      left: isMobile && !isTablet ? '0.2rem' : '-0.5rem',
      bottom: isTablet ? '-0.5em' : isMobile ? '-0.9em' : '-0.2em',
    },
    TimerBackground: {
      ...defaultTheme.BottomBar.TimerBackground,
      height: '100%',
      objectFit: 'contain',
      bottom: isMobile ? '-0.2em' : '-0.5em',
    },
    BarChestItem: {
      ...defaultTheme.BottomBar.BarChestItem,
      marginLeft: isMobile ? (isTablet ? '2rem' : '5rem') : '3rem',
      marginRight: isMobile ? '1rem' : '2.5rem',
    },
  },
  RewardCenter: {
    ...defaultTheme.RewardCenter,
    CardContainerMobile: {
      ...defaultTheme.RewardCenter.CardContainerMobile,
      ...(isAndroid &&
        !isTablet &&
        isMobile && { marginTop: isStandalonePWA ? '0.5vh !important' : '6.5vh !important' }),
    },
  },
  MessageDetails: {
    ...defaultTheme.MessageDetails,
    ScrollBar,
  },
  HistoryList: {
    ...defaultTheme.HistoryList,
    ScrollBar,
  },
  OfferList: {
    ...defaultTheme.OfferList,
    ScrollBar,
  },
  MissionsProgress: {
    ...defaultTheme.MissionsProgress,
    TextProgress: {
      ...defaultTheme.MissionsProgress.TextProgress,
      left: windowWidth < 1400 ? 50 : 65,
      top: windowWidth < 1400 ? '-47%' : '-8%',
    },
    RankContainerWithNoCard: {
      ...defaultTheme.MissionsProgress.RankContainerWithNoCard,
      right: windowWidth < 1400 ? 'calc(50% + 46px)' : 'calc(50% + 41px)',
    },
    ProgressBarFill: {
      ...defaultTheme.MissionsProgress.ProgressBarFill,
      background:
        'linear-gradient(to bottom, rgba(237, 28, 143, 1) 0%, rgba(244, 134, 243, 1) 50%, rgba(237, 28, 143, 1) 100%)',
    },
    BarShineEffect: {
      display: 'none',
    },
    TimeText: {
      ...defaultTheme.MissionsProgress.TimeText,
      fontSize: 19,
    },
    BarLabel: {
      ...defaultTheme.MissionsProgress.BarLabel,
      ...(isMobile && !isAndroid && { left: '0.5vw' }),
    },
  },
  BattleProgressTooltip: {
    ...defaultTheme.BattleProgressTooltip,
    Title: {
      ...defaultTheme.BattleProgressTooltip.Title,
      textShadow: '1px 1px 1px #036494',
    },
    LeaderboardHeader: {
      ...defaultTheme.BattleProgressTooltip.LeaderboardHeader,
      textShadow: '1px 1px 1px #036494',
    },
  },
  BattlesGoal: {
    ...defaultTheme.BattlesGoal,
    InfoText: {
      ...defaultTheme.BattlesGoal.InfoText,
      textShadow: '0px 2px 0px #035b87',
    },
    Amount: {
      ...defaultTheme.BattlesGoal.Amount,
      textShadow: '0px 3px 0px #035b87',
    },
  },
  BattlesRankingTable: {
    ...defaultTheme.BattlesRankingTable,
    TableHeaderItem: {
      ...defaultTheme.BattlesRankingTable.TableHeaderItem,
      textShadow: '0px 3px 0px #035b87',
    },
  },
  BattlesReward: {
    ...defaultTheme.BattlesReward,
    InfoText: {
      ...defaultTheme.BattlesReward.InfoText,
      textShadow: '0px 3px 0px #035b87',
    },
    InfoAmountContainer: {
      ...defaultTheme.BattlesReward.InfoAmountContainer,
      textShadow: '0px 3px 0px #035b87',
    },
    Amount: {
      ...defaultTheme.BattlesReward.Amount,
      textShadow: '0px 3px 0px #035b87',
    },
  },
  BattlesTabsScreen: {
    ...defaultTheme.BattlesTabsScreen,
    InfoText: {
      ...defaultTheme.BattlesTabsScreen.InfoText,
      textShadow: '0px 3px 0px #035b87',
    },
  },
  MissionCard: {
    ...defaultTheme.MissionCard,
    TimeLeftIcon: {
      ...defaultTheme.MissionCard.TimeLeftIcon,
      ...(isNotStandaloneMobilePWA && { marginTop: isAndroid ? 1 : 7 }),
    },
  },
  LinkAccount: {
    ...defaultTheme.LinkAccount,
    Description: {
      ...defaultTheme.LinkAccount.Description,
      padding: '0 11%',
    },
    LinkAccountContainer: {
      ...defaultTheme.LinkAccount.LinkAccountContainer,
      position: 'relative',
    },
    AvailableCards: {
      ...defaultTheme.LinkAccount.AvailableCards,
      position: 'absolute',
      margin: isMobile && !isTablet ? (isAndroid ? '3.5rem 5.7vw' : '3.5rem 8.2vw') : '3.5rem 7.5rem',
    },
    LightDividerUp: {
      ...defaultTheme.LinkAccount.LightDividerUp,
      display: 'flex',
    },
    LightDividerDown: {
      ...defaultTheme.LinkAccount.LightDividerDown,
      display: 'flex',
    },
  },
  ShopScreen: {
    ...defaultTheme.ShopScreen,
    ShopContainer: {
      ...defaultTheme.ShopScreen.ShopContainer,
      PackagesContainer: {
        ...defaultTheme.ShopScreen.ShopContainer.PackagesContainer,
        padding: '6% 5.5rem 0.65rem',
        CoinItemContainer: {
          ...defaultTheme.ShopScreen.ShopContainer.PackagesContainer.CoinItemContainer,
          marginTop: windowWidth < 1300 && windowHeight > 850 ? '15px' : '5px',
        },
        CoinItem: {
          ...defaultTheme.ShopScreen.ShopContainer.PackagesContainer.CoinItem,
          left: windowWidth < 1400 ? '0.8%' : '1%',
          width: '97%',
        },
      },
    },
    SaleTimer: {
      ...defaultTheme.ShopScreen.SaleTimer,
      top: '10%',
    },
  },
  CoinItem: {
    ...defaultTheme.CoinItem,
    LoyaltyIconCapWithBadge: {
      ...defaultTheme.CoinItem.LoyaltyIconCapWithBadge,
      height: '96%',
    },
    LoyaltyIconGoldapWithBadge: {
      ...defaultTheme.CoinItem.LoyaltyIconGoldapWithBadge,
      height: '97%',
    },
  },
  MessagesHeader: {
    ...defaultTheme.MessagesHeader,
    Image: {
      ...defaultTheme.MessagesHeader.Image,
      height: '6rem',
    },
  },
  Start: {
    ...defaultTheme.Start,
    Logo: {
      ...defaultTheme.Start.Logo,
      marginTop: isTablet || !isMobile ? '6%' : isStandalonePWA ? '3%' : 0,
    },
    MainContentContainer: {
      ...defaultTheme.Start.MainContentContainer,
      marginTop: isTablet || !isMobile ? 30 : isStandalonePWA ? 5 : -20,
    },
    BottomBarFirstLine: {
      ...defaultTheme.Start.BottomBarFirstLine,
      marginTop: isMobile ? 10 : 35,
    },
    BottomBarFooterText: {
      ...defaultTheme.Start.BottomBarFooterText,
      marginTop: 0,
      marginBottom: -10,
    },
    BottomBarContainer: {
      ...defaultTheme.Start.BottomBarContainer,
      height: isTablet ? 160 : isMobile ? 170 : 'unset',
      width: isMobile ? '102%' : '100%',
      left: isMobile ? -5 : 0,
    },
    SplashScreenBackground: {
      ...defaultTheme.Start.SplashScreenBackground,
      backgroundPosition: isNotStandaloneMobilePWA ? 'center 75%' : 'center',
    },
  },
  RewardHome: {
    ...defaultTheme.RewardHome,
    RewardImagePlaceholder: {
      ...defaultTheme.RewardHome.RewardImagePlaceholder,
      borderRadius: '30px',
    },
    RewardImage: {
      ...defaultTheme.RewardHome.RewardImage,
      borderRadius: '30px',
    },
    RewardHoverOverlay: {
      ...defaultTheme.RewardHome.RewardHoverOverlay,
      borderRadius: '30px',
    },
  },
  RewardListItem: {
    ...defaultTheme.RewardListItem,
    RewardImagePlaceholderContainer: {
      ...defaultTheme.RewardListItem.RewardImagePlaceholderContainer,
      borderRadius: '30px',
    },
    OfferCost: {
      ...defaultTheme.RewardListItem.OfferCost,
      height: '11%',
      top: '-28.5%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '4px',
      paddingRight: '5%',
      marginBottom: '0.5em',
    },
  },
  SignUp: {
    ...defaultTheme.SignUp,
    ErrorMessage: {
      ...defaultTheme.SignUp.ErrorMessage,
      color: theme.palette.common[1],
    },
    CheckBox: {
      ...defaultTheme.SignUp.CheckBox,
      height: isMobile ? (isAndroid ? 30 : 35) : 20,
    },
  },
  NotificationModal: {
    ...defaultTheme.NotificationModal,
    HeaderContainer: {
      ...defaultTheme.NotificationModal.HeaderContainer,
      height: '25%',
    },
  },
  SideBar: {
    ...defaultTheme.SideBar,
    MenuContainer: {
      ...defaultTheme.SideBar.MenuContainer,
      height: isTablet ? 'calc(100dvh - 7rem - 7rem)' : isMobile ? '103%' : 'calc(100dvh - 5rem - 5rem)', // 100dvh - bottom bar height - top bar height
      borderBottomRightRadius: '8vh',
      borderTopRightRadius: '8vh',
      border: '5px solid #008dc5',
      background: 'linear-gradient(to bottom, #003F57 0%, #00506E 25%, #006D95 50%, #00506E 75%, #003F57 100%)',
    },
    ItemButton: {
      ...defaultTheme.SideBar.ItemButton,
      height: '17.5vh',
    },
    MenuItemText: {
      ...defaultTheme.SideBar.MenuItemText,
      fontSize: isStandalonePWA && !isTablet ? '2.6vw' : isMobile && !isTablet ? '2.1vw' : '3.1vw',
    },
  },
  Bar: {
    ...defaultTheme.Bar,
    BarContainer: {
      ...defaultTheme.Bar.BarContainer,
      background: 'linear-gradient(180deg, rgba(84, 85, 85, 1) 0%, rgba(143, 143, 143, 1) 100%)',
    },
    BarProgress: {
      ...defaultTheme.Bar.BarProgress,
      background: `linear-gradient(
        180deg,
        rgba(237, 28, 143, 1) 0%,
        rgba(244, 134, 243, 1) 50%,
        rgba(237, 28, 143, 1) 100%
      )`,
    },
  },
  VIPItem: {
    ...defaultTheme.VIPItem,
    VipPackageContainer: {
      ...defaultTheme.VIPItem.VipPackageContainer,
      background: `
          linear-gradient(-45deg, #0f3b5a, #1d5d83) padding-box,
          linear-gradient(-45deg, #004461, #004461, #004461, #0097dc, #0097dc) border-box
        `,
      backgroundOrigin: 'border-box',
      backgroundClip: 'padding-box, border-box',
    },
    LogoImage: {
      ...defaultTheme.VIPItem.LogoImage,
      width: !isTablet && isAndroid ? 180 : windowWidth > 1500 ? 230 : 200,
    },
  },
  OfferDetailDescription: {
    ...defaultTheme.OfferDetailDescription,
    ButtonIcon: {
      ...defaultTheme.OfferDetailDescription.ButtonIcon,
      marginBottom: 2,
    },
    ButtonText: {
      ...defaultTheme.OfferDetailDescription.ButtonText,
      paddingBottom: '3%',
    },
  },
  TimeRemaining: {
    ...defaultTheme.TimeRemaining,
    VIPTimer: {
      ...defaultTheme.TimeRemaining.VIPTimer,
      top: pwaStyleAdapter(5.5, 'rem'),
    },
  },
  PurchaseFlow: {
    ...defaultTheme.PurchaseFlow,
    billingProfileSelect: {
      ...defaultTheme.PurchaseFlow.billingProfileSelect,
      border: `1px solid #5a91af`,
    },
  },
  BillingProfile: {
    ...defaultTheme.BillingProfile,
    AddDeleteProfileText: {
      ...defaultTheme.BillingProfile.AddDeleteProfileText,
      border: `4px solid ${theme.palette.primary[31]}`,
    },
  },
  LobbyOverlay: {
    ...defaultTheme.LobbyOverlay,
    MainSceneContainer: {
      ...defaultTheme.LobbyOverlay.MainSceneContainer,
      paddingTop: isNotStandaloneMobilePWA ? (windowHeight < 650 ? '5.2rem' : '4.5rem') : NavHeight,
    },
  },
};

export default TiTheme;
